import { capitalizeFLetter } from "../utils/function";

const dataMenu = (city = "blitar", page = "", urlParams = {}) => {
  if (page === "landing-page") {
    return [
      { label: "Beranda", link: `announce`, hideMenu: false },
      {
        label: "Jadwal Event",
        link: `timeline`,
        hideMenu: false,
      },
      // {
      //   label: "Galeri",
      //   link: `gallery`,
      //   hideMenu: false,
      // },
      {
        label: "Tentang Piala by.U",
        link: `info`,
        hideMenu: false,
      },

      {
        label: "Perjalanan Piala by.U",
        link: `perjalanan-pialabyu`,
        hideMenu: false,
      },
      // {
      //   label: "Jadwal Event",
      //   link: `jadwal-event`,
      //   hideMenu: false,
      // },

      {
        label: "Paket Spesial",
        link: `footer-landing`,
        hideMenu: city === "blitar",
      },
    ];
  } else if (page === "registered-user") {
    return [
      { label: "Dashboard", link: "/", hideMenu: false },

      // {
      //   label: `Piala by.U ${capitalizeFLetter(city)}`,
      //   link: `/${city}`,
      //   hideMenu: false,
      // },

      {
        label: "Kontak Tim Piala by.U",
        link: "external",
        hideMenu: false,
        onClick: () => window.open("https://wa.me/6285117354898", "_blank"),
      },
      // {
      //   label: "Logout",
      //   link: `external`,
      //   onClick: () => {
      //     localStorage.clear();
      //     window.location.reload();
      //     window.location.href = "/";
      //   },
      //   hideMenu: false,
      // },
    ];
  } else if (city === "soc") {
    if (urlParams.year === "2024") {
      return [
        { label: "Beranda", link: `/${city}`, hideMenu: false },
        {
          label: "Jadwal Event",
          link: `/${city}/jadwal-pertandingan`,
          hideMenu: false,
        },

        {
          label: "Klasemen & Statistik",
          link: `/${city}/klasemen-pertandingan`,
          hideMenu: false,
        },
        { label: "Info Lokasi", link: `/${city}/info-lokasi`, hideMenu: false },
        // {
        //   label: "Jadwal Acara",
        //   link: `/${city}/jadwal-acara`,
        //   hideMenu: false,
        // },
        {
          label: "Explore Piala by.U",
          link: `/main`,
          hideMenu: false,
        },
        //  { label: "RSVP", link: "/rsvp", hideMenu: false },
      ];
    }
    return [
      { label: "Beranda", link: `/${city}`, hideMenu: false },
      {
        label: "Drawing",
        link: `/${city}/drawing`,
        hideMenu: urlParams.year === "2024",
      },
      {
        label: "Jadwal Event",
        link: `/${city}/jadwal-pertandingan`,
        hideMenu: false,
      },

      {
        label: "Klasemen & Statistik",
        link: `/${city}/klasemen-pertandingan`,
        hideMenu: false,
      },
      { label: "Info Lokasi", link: `/${city}/info-lokasi`, hideMenu: false },
      // {
      //   label: "Jadwal Acara",
      //   link: `/${city}/jadwal-acara`,
      //   hideMenu: false,
      // },
      {
        label: "Explore Piala by.U",
        link: `/main`,
        hideMenu: false,
      },
      //  { label: "RSVP", link: "/rsvp", hideMenu: false },
    ];
  }
  if (city === "press-con") {
    return [
      { label: "Beranda", link: `announce`, hideMenu: false },
      {
        label: "Jadwal Event",
        link: "jadwal",
        hideMenu: false,
      },
      // {
      //   label: "Galeri",
      //   link: `gallery`,
      //   hideMenu: false,
      // },
      {
        label: "Daftar Piala by.U",
        link: "daftar",
        hideMenu: false,
      },
      {
        label: "Golden Ticket",
        link: "/golden-ticket",
        anotherPage: true,
        hideMenu: false,
      },
      // {
      //   label: "Paket Spesial",
      //   link: `footer-landing`,
      //   hideMenu: false,
      // },
    ];
  } else {
    return [
      { label: "Beranda", link: `/${city}`, hideMenu: false },
      {
        label: "Jadwal Pertandingan",
        link: `/${city}/jadwal-pertandingan`,
        hideMenu: false,
      },
      {
        label: "Klasemen & Statistik",
        link: `/${city}/klasemen-pertandingan`,
        hideMenu: false,
      },
      { label: "Info Lokasi", link: `/${city}/info-lokasi`, hideMenu: false },
      // {
      //   label: "Jadwal Acara",
      //   link: `/${city}/jadwal-acara`,
      //   hideMenu: false,
      // },
      {
        label: "Explore Piala by.U",
        link: `/main`,
        hideMenu: false,
      },
      // {
      //   label: "Info Lomba",
      //   link: `${city}/info-lomba`,
      //   hideMenu: city === "blitar",
      // },
    ];
  }
};

export default dataMenu;
